// useWallet - React hook exposing Phantasma Link connection state to the UI.
import { useState, useCallback, useEffect } from 'react';
import { connectWallet, disconnectWallet } from './wallet';

export const useWallet = () => {
  const [status, setStatus] = useState('disconnected'); // disconnected | connecting | connected | error
  const [account, setAccount] = useState(null); // { address, name, balances:{SYMBOL:amount} }
  const [error, setError] = useState(null);

  const connect = useCallback(async () => {
    setStatus('connecting');
    setError(null);
    try {
      const acc = await connectWallet();
      setAccount(acc);
      setStatus('connected');
    } catch (e) {
      setError(e?.message || String(e));
      setStatus('error');
    }
  }, []);

  const disconnect = useCallback(() => {
    disconnectWallet();
    setAccount(null);
    setStatus('disconnected');
    setError(null);
  }, []);

  // Tidy up the socket if the component unmounts mid-session.
  useEffect(() => () => disconnectWallet(), []);

  return { status, account, error, connect, disconnect };
};
